module.exports = __webpack_public_path__ + "img/preview-10.20bfd764.png";